import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4302cf84"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "AModalConsentimento__Texto" }, " Este site utiliza cookies para melhorar a sua experiência. ", -1))

import { ref } from "vue"
  import { usarClarity } from "@/composable/UsarClarity/usarClarity"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AModalConsentimento',
  setup(__props) {

  const { habilitarClarityComConsentimento } = usarClarity()

  const modalEstaHabilitado = ref(true)
  const classeCssModal = ref("")

  const fecharModal = (): void => {
    classeCssModal.value = "AModalConsentimento__FecharModal"
    setTimeout(() => {
      modalEstaHabilitado.value = false
    }, 800)
  }

  const aceitarMonitoramento = (): void => {
    try {
      habilitarClarityComConsentimento()
      localStorage.setItem("consentimentoDeMonitoramento", "aceito")
      fecharModal()
    } catch (erro) {
      return
    }
  }

  const rejeitarMonitoramento = (): void => {
    try {
      localStorage.setItem("consentimentoDeMonitoramento", "negado")
      fecharModal()
    } catch (erro) {
      return
    }
  }

return (_ctx: any,_cache: any) => {
  return (modalEstaHabilitado.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["AModalConsentimento", classeCssModal.value]),
        "data-testid": "AModalConsentimento"
      }, [
        _createElementVNode("div", { class: "AModalConsentimento__Container" }, [
          _hoisted_1,
          _createElementVNode("div", { class: "AModalConsentimento__Botoes" }, [
            _createElementVNode("button", {
              onClick: rejeitarMonitoramento,
              class: "AModalConsentimento__BotaoRejeitar",
              "data-testid": "AModalConsentimento__BotaoRejeitar"
            }, " rejeitar "),
            _createElementVNode("button", {
              onClick: aceitarMonitoramento,
              class: "AModalConsentimento__BotaoAceitar",
              "data-testid": "AModalConsentimento__BotaoAceitar"
            }, " aceitar cookies ")
          ])
        ])
      ], 2))
    : _createCommentVNode("", true)
}
}

})